import styled from 'styled-components'

export const Screen = styled.main`
  width: min(100%, 680px);
  font-family: Poppins, sans-serif;
  margin: 48px auto;
  padding: 0 24px;
  color: ${p => p.theme.palette.colors.text};
  @media (max-width: 600px) { margin: 28px auto; padding: 0 12px; }
`
export const Intro = styled.header`
  margin-bottom: 28px;
  span { font-size: 14px; font-weight: 600; color: ${p => p.theme.palette.colors.muted}; }
  h1 { font-family: Gilroy; font-size: clamp(28px, 5vw, 38px); font-weight: 700; margin: 12px 0; }
  p { font-family: Poppins, sans-serif; line-height: 1.7; color: ${p => p.theme.palette.colors.muted}; }
`
export const FormPanel = styled.section`
  border-top: 1px solid ${p => p.theme.palette.colors.border};
  padding-top: 24px;
`
export const Actions = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 18px;
`
export const Message = styled.p`
  color: ${p => p.theme.palette.colors.text};
  margin: 16px 0;
`
